// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/fonts/materialicons/materialicons.css
// module id = 2060
// module chunks = 0